import { useHelpSections } from '../../services/helpSections/getList';

export const useSupport = () => {
  const { data, isLoading: isHelpSectionsLoading } = useHelpSections();

  return {
    helpSections: data?.sections ?? [],
    isHelpSectionsLoading
  };
};
